module.exports = __webpack_public_path__ + "img/oxford-logo-white-english.f0bfbfc3.svg";